import React from "react";
import { dealUrl } from "../constant";
import { useLoading, useDeals, useLanguage, useCookie } from "../hooks";
import axios from "axios";
import { getLanguage, getCookieAccepted } from "./storage";

const GetAllDeals = () => {
    const [, setIsLoading] = useLoading();
    const [, setDeals] = useDeals();
    const [userLanguage, setUserLanguage] = useLanguage();
    const [, setCookie] = useCookie();

    const language = getLanguage();
    const cookieAccepted = getCookieAccepted();


    React.useEffect(() => {
        if (language && language !== userLanguage) {
            setUserLanguage(language);
        }
    }, [language, userLanguage, setUserLanguage]);

    React.useEffect(() => {
        if (!cookieAccepted) {
            setCookie(false);
        }
    }, [cookieAccepted, setCookie]);

    const getDeals = React.useCallback(() => {
        setIsLoading(true);
        axios
            .get(dealUrl, {}, {
                timeout: 5500,
            })
            .then((response) => {
                const { data } = response;
                (data !== "0 results") && setDeals(data);
                setIsLoading(false);
            }).catch((error) => {
                console.log(error);
            });
    }, [setIsLoading, setDeals]);

    React.useEffect(() => {
        getDeals();
    }, [getDeals]);

    return null;
};

export default GetAllDeals;
